import { defineNuxtPlugin } from "#app";

import {
  getSentry,
  startPreInitErrorHandlers,
  stopPreInitErrorHandlers,
} from "@solvari/utils";

// ~197 kB of the entry chunk → loads after hydration. Until it lands, trackVueErrors installs
// the fallback handler, startPreInitErrorHandlers covers what Vue's handler never sees
// (rejections, timers, listeners), and getSentry buffers captures; initSentryRoot replays them.
export default defineNuxtPlugin((nuxtApp) => {
  getSentry().trackVueErrors(nuxtApp.vueApp);
  startPreInitErrorHandlers();

  nuxtApp.hook("app:suspense:resolve", () => {
    void import("~/shared/libs/lazy/sentryService.ts").then(
      ({ initSentryRoot }) => {
        initSentryRoot({ project: "main-site-fe", stripUrlFragments: true });

        // initSentryRoot bails on bots, unsupported browsers and local, so it never flushes
        // and never removes these. Dropping them here stops a permanent duplicate listener.
        stopPreInitErrorHandlers();

        // Sentry's Vue integration chains onto an existing errorHandler → clear the
        // fallback first or every Vue error reports twice.
        nuxtApp.vueApp.config.errorHandler = undefined;
        getSentry().trackVueErrors(nuxtApp.vueApp);
      },
    );
  });
});
